import { Components } from "../components";

export function TestView(props){
    return (
        <>
            <Components.RecapStepV2 />
        </>
    )
}